import client from './api-client';

export const serviceBuscarPagosAprobados = async (query) => {
    try {
        const response = await client.getSelect(`emision-pagos-cia/emitir?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceObtenerEstadoEmision = async (query) => {
    try {
        const response = await client.getSelect(`emision-pagos-cia/emitir?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceEmitirPagos = async (body) => {
    try {
        const response = await client.postCia('emision-pagos-cia/emitir', body);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceSubirCupon = async (body) => {
    try {
        const response = await client.postCia('emision-pagos-cia/emitir', body);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceNotificarCia = async (body) => {
    try {
        const response = await client.postCia('emision-pagos-cia/emitir', body);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceObtenerOpcionesReversa = async (body) => {
    try {
        const response = await client.postCia('emision-pagos-cia/emitir', body);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceReversarRespuesta = async (body) => {
    try {
        const response = await client.postCia('emision-pagos-cia/emitir', body);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}
